<template>
  <section>
<!-- 工具条 -->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px; margin-bottom: 15px;">
      <el-button type="primary" size="small" @click="showBatchWuliu">批量修改物流</el-button>
      <!-- <el-button size="small" type="danger" @click="smsRemind">拆单短信提醒</el-button> -->
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading"
              @expand="expand"
              :row-key="getRowKeys"
              :expand-row-keys="expands">
      <el-table-column type="expand">
        <template scope="scope">
          <el-collapse v-model="activeNames" accordion>
            <el-collapse-item title="商品列表" name="1">
              <div style="text-align: center;">
                <el-table :data="tableDataProduct"
                          border>
                  <el-table-column
                    label="名称"
                    prop="pro_name"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    label="价格"
                    prop="price"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    label="规格"
                    prop="spec_name"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    label="数量"
                    prop="pronum"
                    align="center">
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>

            <el-collapse-item title="物流状态" name="2">
                  <el-tabs v-model="wuliuAction" type="border-card">
                <el-tab-pane
                  v-for="(item, index) in wuliuStatusTabs"
                  :label="item"
                  :name="item"
                  :key="index"
                  style="text-align: center;">
                <!-- <el-steps :space="100" :active="wuliuStatus" finish-status="success"> -->
                 <!--  <el-step title="揽货"></el-step>
                  <el-step title="跨镜运输"></el-step>
                  <el-step title="清关完成"></el-step>
                  <el-step title="国内派送"></el-step>
                  <el-step title="签收"></el-step>
                  <el-step title="结束"></el-step>
                </el-steps> -->
                <div v-if="wuliuInfos && wuliuInfos.length > 0" style="text-align: left;">物流信息：<p v-for="(item, index) in wuliuInfos" :key="index">{{item.context}}  {{item.time}}</p></div>
                 </el-tab-pane>
               </el-tabs>
            </el-collapse-item>
          </el-collapse>
        </template>
      </el-table-column>
      <el-table-column
        label="订单编号"
        prop="order_num"
        align="center">
      </el-table-column>
      <el-table-column
        label="子订单编号"
        prop="suborder_num"
        align="center">
      </el-table-column>
      <el-table-column
        label="物流单位"
        prop="wuliu_company"
        align="center">
      </el-table-column>
      <el-table-column
        label="物流编号"
        prop="wuliu_num"
        align="center">
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        align="center">
        <template scope="scope">
          <el-button  type="primary"  size="medium" @click="showWuliu(scope.row)">修改物流</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!--编辑界面-->
    <el-dialog title="修改物流" v-model="wuliuVisbile">
        <el-row>
            <el-col :span="24">
              <el-select v-model="wuliuCom"  placeholder="选择物流单位">
                <el-option
                  v-for="(item, index) in wuliuCompany"
                  :key="index"
                  :label="item"
                  :value="item"
                  size="small">
                </el-option>
              </el-select>
            </el-col>
        </el-row>

        <el-row style="margin-top: 15px;">
            <el-col :span="24">
                <el-input v-model="wuliuNum" placeholder="物流编号"></el-input>
            </el-col>
        </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!-- ================= 新增：批量编辑界面 ================= -->
    <el-dialog title="批量发货 / 修改物流" v-model="batchWuliuVisible" width="60%">
      <el-row style="margin-bottom: 15px;">
        <el-col :span="24">
          <span style="font-weight: bold;">统一物流单位：</span>
          <el-select v-model="batchWuliuCom" placeholder="选择物流单位（对以下所有订单生效）">
            <el-option
              v-for="(item, index) in wuliuCompany"
              :key="index"
              :label="item"
              :value="item"
              size="small">
            </el-option>
          </el-select>
        </el-col>
      </el-row>

      <el-table :data="batchTableData" border max-height="400">
        <el-table-column label="子订单编号" prop="suborder_num" align="center"></el-table-column>
        <el-table-column label="当前物流状态" align="center">
          <template scope="scope">
            <el-tag v-if="scope.row.wuliu_num" type="success">已发货</el-tag>
            <el-tag v-else type="info">未发货</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="物流单号" align="center" width="250">
          <template scope="scope">
            <!-- 直接在表格里输入单号 -->
            <el-input v-model="scope.row.new_wuliu_num" placeholder="请输入物流单号" clearable></el-input>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="batchWuliuVisible = false">取消</el-button>
        <el-button type="primary" @click.native="batchEditSubmit" :loading="batchSubmitLoading">批量提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import basicdata from '../../static/config/basicdata.js'

  export default {
    data() {
      return {
        tableData: [],
        listLoading: false,
        wuliuVisbile: false,
        orderNum: this.$route.params.orderNum,
        wuliuNum: '',
        tableDataProduct: [],
        expands: [],
        getRowKeys(row) {
          return row.id;
        },
         wuliuStatusTabs: [],
               wuliuAction: '',
        wuliuStatus: 0,
        wuliuInfos: [],
        activeNames: '1',
        wuliuCom:'',
        wuliuCompany: basicdata.wuliuCompany,
        // ========= 新增的变量 =========
        lastUsedWuliuCom: '', // 记忆用户最后一次选的快递公司
        batchWuliuVisible: false,
        batchSubmitLoading: false,
        batchWuliuCom: '',
        batchTableData: [],
      }
    },
    methods: {
      getList() {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/suborder/'+this.orderNum
        ).then(response => {
          let data = response.data;
          if(data.state) {
            this.tableData = data.msg;
          } else {
            this.$message({
              message: data.msg,
              type: 'warning'
            });
          }
          this.listLoading = false;
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
    // 【优化】原有的单行修改：加入快递公司记忆功能
      showWuliu(row) {
        this.wuliuVisbile = true;
        this.wuliuNum = row.wuliu_num;
        this.subOrderNum = row.suborder_num;
        // 如果当前订单有快递，就用当前的；如果没有，就用上一次记住的快递
        this.wuliuCom = row.wuliu_company || this.lastUsedWuliuCom;
      },
      // 添加物流
      editSubmit() {
this.$axios.put(config.api_url + '/suborder/'+this.orderNum+'/'+this.subOrderNum+'/'+this.wuliuNum+'/'+this.wuliuCom)
        .then(response => {
          let data = response.data;
          if(data.state) {
             this.$message({ message: '提交成功', type: 'success' });
             this.lastUsedWuliuCom = this.wuliuCom; // 记住本次使用的快递
          } else {
            this.$message({ message: data.msg, type: 'warning' });
          }
          this.getList();
          this.wuliuVisbile = false;
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '提交异常，请联系管理员',
            type: 'error'
          });
        })
      },
      // 短信提醒
      smsRemind() {
        this.$confirm('是否确认发送短信提醒？', '提示', {}).then(() => {
          this.$axios.post(config.api_url+'/order/sms_remind/'+this.orderNum
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '发送成功',
                type: 'success'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '发送异常，请联系管理员',
              type: 'error'
            });
          });
        });
      },
      //查询订单状态，物流状态等。
      expand(row, expanded) {
        if(expanded) {
            this.wuliuStatusTabs = row.wuliu_num ? row.wuliu_num.split(',') : [];
          this.wuliuAction = this.wuliuStatusTabs[0];
          this.getProduct(row.suborder_ids);
          this.getWuliuStatus(row.wuliu_num,row.order_num);
          this.expands = [];
          this.expands.push(row.id);
        }
      },
      // 1. 打开批量编辑弹窗
      showBatchWuliu() {
        if (!this.tableData || this.tableData.length === 0) {
          return this.$message.warning('当前没有子订单可以操作');
        }
        
        this.batchWuliuVisible = true;
        // 默认带出上次选的物流公司
        this.batchWuliuCom = this.lastUsedWuliuCom || ''; 
        
        // 深拷贝一份数据到批量表格中，避免取消时影响外层表格，并初始化 new_wuliu_num
        this.batchTableData = this.tableData.map(item => {
          return {
            ...item,
            // 默认把原有的单号填进去，方便修改；如果是空的就是发新货
            new_wuliu_num: item.wuliu_num || '' 
          }
        });
      },

      // 2. 批量提交
      batchEditSubmit() {
        if (!this.batchWuliuCom) {
          return this.$message.warning('请选择统一物流单位');
        }

        // 筛选出填写了单号的订单
        let validItems = this.batchTableData.filter(item => item.new_wuliu_num && item.new_wuliu_num.trim() !== '');
        
        if (validItems.length === 0) {
          return this.$message.warning('请至少为一个子订单填写物流单号');
        }

        this.batchSubmitLoading = true;

        // 使用 Promise.all 包装所有请求，不需要后端改接口，前端并发发送
        let requestPromises = validItems.map(item => {
          return this.$axios.put(config.api_url + '/suborder/' + this.orderNum + '/' + item.suborder_num + '/' + item.new_wuliu_num + '/' + this.batchWuliuCom);
        });

        Promise.all(requestPromises).then(responses => {
          this.batchSubmitLoading = false;
          
          // 检查是否有失败的请求 (根据你们后端的 data.state 逻辑)
          let hasError = responses.some(res => !res.data.state);
          if (hasError) {
             this.$message.warning('部分订单提交失败，请检查列表');
          } else {
             this.$message.success('批量发货成功！');
             this.batchWuliuVisible = false;
             this.lastUsedWuliuCom = this.batchWuliuCom; // 记住本次使用的快递
          }
          this.getList(); // 刷新列表
          
        }).catch(error => {
          console.log(error);
          this.batchSubmitLoading = false;
          this.$message.error('网络异常，请刷新后查看状态');
          this.getList();
        });
    },
      // 获取商品列表
      getProduct(orderIds) {
        this.$axios.get(config.api_url + '/suborder/form/'+orderIds
        ).then(response => {
          if(response.data.state) {
            this.tableDataProduct = response.data.msg;
          } else {
            this.$message({
              message: '获取商品列表失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            message: '获取商品列表异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //查询物流状态
      getWuliuStatus(wuliuNum,orderNum) {
        if(wuliuNum) {
          this.$axios.get(config.api_url + '/wuliu/'+wuliuNum+'/'+orderNum
          ).then(response => {
            let data = response.data;
            if(data.state) {
              let result = data.msg;
              //this.wuliuStatus = basicdata.wuliuStatus[result.wuliustatus];
              this.wuliuInfos = [];
               let obj = result.wuliuinfo ? JSON.parse(result.wuliuinfo) : '';
              if(obj&& obj.length > 0) {
                this.wuliuInfos = obj;
              }
            } else {
              this.$message({
                message: '查询物流状态失败，请联系管理员',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '查询物流状态异常，请联系管理员',
              type: 'error'
            });
          });
        } else {
          this.wuliuInfos = [];
          this.wuliuStatus = 0;
        }
      },
    },
    created() {
      this.getList();
    }
  }
</script>



// WEBPACK FOOTER //
// Chaidan.vue?6955c9df